import React, { memo, useCallback, useEffect, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroller';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { createSelector } from 'reselect';
import { logging, logPostInfo } from '../../actions/log';
import { getRankList, setScroll } from '../../actions/wallpaper';
import Loading from '../../components/Loading/Loading';
import ScrollTop from '../../components/ScrollTop/ScrollTop';
import WallpaperCard from '../../components/WallpaperCard/WallpaperCard';
import { getQueryString } from '../../utils/utils';
import Blank from './Blank';
import styles from './WallPaperRank.module.less';

const selectWpRankList = createSelector(
  state => state.wallpaper,
  wallpaper => wallpaper.rankList,
);
const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);
const selectScroll = createSelector(
  state => state.wallpaper && state.wallpaper,
  info => {
    return info.scroll;
  },
);

export default memo(() => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { action } = history;
  const rankList = useSelector(selectWpRankList);
  const logInfoData = useSelector(selectLogInfo);

  const [contentElement, setContentElement] = useState(null);
  const code = getQueryString('code');
  const wallpaperId = getQueryString('wallpaperId');
  const [contentElHeight, setContentElHeight] = useState(0);
  const scrollInfo = useSelector(selectScroll);
  /**
   * 统计页面浏览时长
   */
  useEffect(() => {
    const initTime = +new Date();
    return () => {
      const leaveTime = +new Date();
      dispatch(
        logging({
          category: 'I',
          action: 'View_Time',
          label: '',
          param2: {
            source: `Wallpaper_RankMore||${code}`,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            initTime,
            leaveTime,
            time: leaveTime - initTime,
            code,
            wallpaperId,
          },
        }),
      );
    };
  }, []);

  /**
   * PUSH 滚动到最顶端
   */
  useEffect(() => {
    const el = document.getElementById('container_content');
    if (action === 'PUSH') {
      el.scrollTo(0, 0);
    }
  }, []);

  useEffect(() => {
    const el = document.getElementById('container_content');
    if (el.scrollTop > 0 && action === 'POP') {
      dispatch(
        setScroll({
          rankScrollTop: 0,
        }),
      );
    }
  }, [rankList]);
  /**
   * POP 滚动到之前位置
   */
  useEffect(() => {
    const el = document.getElementById('container_content');
    if (contentElHeight && scrollInfo && scrollInfo.rankScrollTop && action === 'POP') {
      if (contentElHeight <= scrollInfo.rankScrollTop) {
        el.scrollTo(0, scrollInfo.rankScrollTop - 20);
      } else {
        el.scrollTo(0, scrollInfo.rankScrollTop);
      }
    }
  }, [contentElHeight]);

  useEffect(() => {
    // 更新页面 PV
    dispatch(
      logging({
        category: 'Wallpaper',
        action: 'P_Wallpaper_RankMore',
        label: '',
        param2: {
          source: `Wallpaper_RankMore||${code}`,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          wallpaperId,
        },
      }),
    );
    dispatch(
      logPostInfo({
        source: `Wallpaper_RankMore||${code}`,
        source_p: logInfoData.source_p,
        source_pp: logInfoData.source_pp,
      }),
    );
    setContentElement(document.getElementById('container_content'));
  }, [dispatch]);

  /**
   * 获取榜单图片
   */
  useEffect(() => {
    if (
      rankList.code !== code ||
      (rankList.list.length < rankList.pagenation.limit &&
        rankList.list.length < rankList.pagenation.count)
    ) {
      dispatch(
        getRankList({
          ...rankList.pagenation,
          skip: 0,
          code,
          wallpaperId,
          refresh: true,
        }),
      );
    }
  }, []);

  const loadMore = useCallback(() => {
    if (
      rankList.load !== true &&
      rankList.code === code &&
      rankList.list.length < rankList.pagenation.count
    ) {
      dispatch(
        getRankList({
          ...rankList.pagenation,
          code,
          wallpaperId,
        }),
      );
    }
  });

  const getClassType = useCallback((index = 0) => {
    const pos = index % 8;
    if (pos > 2 && pos < 5) {
      if (pos === 3) {
        return 'big_space';
      }
      return 'big';
    }
    if (pos === 1 || pos === 6) {
      return 'small_center';
    }
    return 'small';
  });

  const handleSaveScrollTop = () => {
    const el = document.getElementById('container_content');
    dispatch(
      setScroll({
        rankScrollTop: el && el.scrollTop,
      }),
    );
  };

  const handleMeasureHeight = useCallback(node => {
    if (node) {
      setContentElHeight(node.clientHeight);
    }
  });

  if (rankList.list.length === 0 && rankList.load) {
    return (
      <div className={styles.loading}>
        <Loading />
      </div>
    );
  }
  if (rankList.list.length === 0 && rankList.load === false) {
    return <Blank load={rankList.load} />;
  }
  return (
    <div className={styles.rank} onClick={handleSaveScrollTop} ref={handleMeasureHeight}>
      {rankList.name && <div className={styles.rank_name}>{rankList.name}</div>}
      {rankList.desc && <div className={styles.rank_desc}>{rankList.desc}</div>}
      {code === rankList.code && (
        <InfiniteScroll
          pageStart={1}
          loadMore={loadMore}
          hasMore={rankList.list.length < rankList.pagenation.count}
          loader={
            <div className="loader" key={0}>
              ----------加载中----------
            </div>
          }
          initialLoad={false}
          useWindow={false}
          getScrollParent={() => contentElement}
        >
          <div className={styles.showreel}>
            {rankList.list.map((item, index) => {
              return (
                <WallpaperCard
                  wallpaper={item}
                  key={index}
                  cardInfo={{
                    pageSource: 'rank',
                    code,
                    classType: getClassType(index),
                    isCollect: true,
                    isWallpaper: true,
                    isDeleteColl: false,
                    isDeleteUsed: false,
                    isPreview: true,
                  }}
                  logInfo={{ source: `Wallpaper_RankMore||${code}` }}
                />
              );
            })}
            {rankList.list.length >= rankList.pagenation.count && rankList.pagenation.count > 5 && (
              <div className="loader" style={{ width: '800px' }}>
                ----------到底啦----------
              </div>
            )}
          </div>
        </InfiniteScroll>
      )}
      <ScrollTop />
    </div>
  );
});
